import { styled } from '@mui/material/styles';
import { CircularProgress } from '@mui/material';

const PREFIX = 'Backdrop';

const classes = {
  root: `${PREFIX}-root`,
};

const Root = styled('div')({
  [`&.${classes.root}`]: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'grid',
    placeContent: 'center',
    height: '100%',
    zIndex: -1,
  },
});

export const Backdrop = () => {
  return (
    <Root className={classes.root}>
      <CircularProgress />
    </Root>
  );
};
